export const licenseLimitExceededMessages = {
  en: {
    title: 'License Limit Exceeded',
    boxTitle: 'License Limit Exceeded',
    explanation: 'Your license has exceeded limit of allowed devices.',
    licenseDeviceLimit: 'License device limit: {licenseLimit}',
    licensedDevicesCount:
      'Licensed devices in current snapshot: {licensedDevices}',
  },
};
